export var defaultDropdownProps = {
    triggerEvent: 'mouseover',
    title: '点击下拉',
    className: '',
    onItemSelect: function (data, e) { return null; },
    disabled: false,
    bordered: true,
};
export var defaultDropdownItemProps = {
    className: '',
    disabled: false,
    title: '',
};
export var defaultGroupItemProps = {
    className: '',
    title: '',
};
